import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {LeaderboardHorizontalTabData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {UILeaderboardUtils} from '../../../shared/scripts/ui_leaderboard/UILeaderboardUtils'

export class UILeaderboardHorizontalTabsController {
    private readonly tabsElements: HTMLDivElement[]
    private readonly dropdownButtonElement: HTMLDivElement
    private readonly dropdownButtonText: Text
    private readonly dropdownContentsElement: HTMLDivElement
    private readonly onHorizontalTabChange: (leaderboardUrl: string) => void

    constructor(onHorizontalTabChange: (leaderboardUrl: string) => void) {
        this.tabsElements = [
            document.querySelector('.leaderboard_tabs_horizontal') as HTMLDivElement,
            document.querySelector('.leaderboard_tabs_dropdown_contents') as HTMLDivElement,
        ]

        this.dropdownButtonElement = document.querySelector('.leaderboard_tabs_dropdown_button') as HTMLDivElement
        this.dropdownButtonText = this.dropdownButtonElement.firstChild as Text
        this.dropdownContentsElement = document.querySelector('.leaderboard_tabs_dropdown_contents') as HTMLDivElement
        this.onHorizontalTabChange = onHorizontalTabChange

        setElementOnClick(this.dropdownButtonElement, () => this.onDropdownButtonClick())
    }

    private onDropdownButtonClick() {
        this.dropdownContentsElement.classList.toggle('visible')
        this.dropdownButtonElement.classList.toggle('active')
    }

    private hideDropdown() {
        this.dropdownContentsElement.classList.remove('visible')
        this.dropdownButtonElement.classList.remove('active')
    }

    private static getLeaderboardName(availableHorizontalTabs: LeaderboardHorizontalTabData[], leaderboardUrl: string): string {
        for(const tab of availableHorizontalTabs) {
            if(tab.leaderboardUrl === leaderboardUrl) return UILeaderboardUtils.tLeaderboardTabName(tab.label)
        }
        return leaderboardUrl
    }

    highlightTab(leaderboardUrl: string) {
        for(const tabContainerElement of this.tabsElements) {
            for(const tab of tabContainerElement.children) {
                const tabElement = tab as HTMLElement
                if(tabElement.dataset.leaderboardUrl === leaderboardUrl) {
                    tab.classList.add('active')
                } else {
                    tab.classList.remove('active')
                }
            }
        }
    }

    updateLeaderboardRegionTabs(availableHorizontalTabs: LeaderboardHorizontalTabData[], leaderboardUrl: string) {
        this.dropdownButtonText.textContent = UILeaderboardHorizontalTabsController.getLeaderboardName(availableHorizontalTabs, leaderboardUrl)

        for(const tabContainerElement of this.tabsElements) {
            tabContainerElement.replaceChildren(...availableHorizontalTabs.map((tab: LeaderboardHorizontalTabData) => {
                const div = document.createElement('div')
                div.classList.add('leaderboard_tab')
                if(leaderboardUrl == tab.leaderboardUrl) div.classList.add('active')
                div.innerText = UILeaderboardUtils.tLeaderboardTabName(tab.label)
                setElementOnClick(div, () => {
                    this.hideDropdown()
                    this.onHorizontalTabChange(tab.leaderboardUrl)
                    this.dropdownButtonText.textContent = UILeaderboardUtils.tLeaderboardTabName(tab.label)
                })
                div.dataset.leaderboardUrl = tab.leaderboardUrl
                return div
            }))
        }
    }
}
